(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746,9495],{

/***/ 89497:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(79350);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageWrapper_PageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(15304);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(83767);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/PageWrapper/PageWrapper.module.scss
var PageWrapper_module = __webpack_require__(70930);
var PageWrapper_module_default = /*#__PURE__*/__webpack_require__.n(PageWrapper_module);
;// CONCATENATED MODULE: ./components/PageWrapper/PageWrapper.tsx






var PageWrapper = function(param) {
    var dateText = param.dateText, titleText = param.titleText, introText = param.introText, _headerContainerClass = param.headerContainerClass, headerContainerClass = _headerContainerClass === void 0 ? "" : _headerContainerClass, _headerSectionClass = param.headerSectionClass, headerSectionClass = _headerSectionClass === void 0 ? "" : _headerSectionClass, _contentContainerClass = param.contentContainerClass, contentContainerClass = _contentContainerClass === void 0 ? "" : _contentContainerClass, children = param.children, aboutData = param.aboutData, additionalHeaderContent = param.additionalHeaderContent, additionalContent = param.additionalContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PageWrapper_module_default()).pageWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((PageWrapper_module_default()).headerContainer, " ").concat((PageWrapper_module_default()).pattern, " ").concat(headerContainerClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "".concat((PageWrapper_module_default()).headerSection, " ").concat(headerSectionClass),
                        children: [
                            !!dateText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).dateContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).dateText,
                                    children: dateText
                                })
                            }),
                            !!titleText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).titleContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "display-lg",
                                    as: "h1",
                                    color: "primary",
                                    weight: "bold",
                                    className: (PageWrapper_module_default()).mainTitle,
                                    children: titleText
                                })
                            }),
                            !!introText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).introContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-xl",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).introText,
                                    children: introText
                                })
                            }),
                            additionalHeaderContent
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "".concat((PageWrapper_module_default()).contentContainer, " ").concat(contentContainerClass),
                    children: children
                }),
                additionalContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                    aboutData: aboutData
                })
            ]
        })
    });
};
/* harmony default export */ var PageWrapper_PageWrapper = (PageWrapper);

;// CONCATENATED MODULE: ./components/PageWrapper/index.ts



/***/ }),

/***/ 79350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _components_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39181);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32033);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43260);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_faq_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49661);
/* harmony import */ var _components_PageWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96424);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38743);









var FaqPage = function(param) {
    var categories = param.categories, faqs = param.faqs, queryId = param.queryId, aboutData = param.aboutData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(categories.length > 0 ? categories[0] : ""), selectedCategory = ref[0], setSelectedCategory = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), expandedQuestionIndex = ref1[0], setExpandedQuestionIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDropdownOpen = ref2[0], setIsDropdownOpen = ref2[1];
    var filteredFaqs = faqs.filter(function(faq) {
        return faq.category === selectedCategory;
    });
    var toggleAnswer = function(index) {
        setExpandedQuestionIndex(expandedQuestionIndex === index ? null : index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: "FAQ",
                description: "Find answers to frequently asked questions about EPEN Ltd. video plugins, licensing, product setup, and support. Get instant answers to your questions!",
                keywords: "faq, frequently asked questions, epen, video plugin, support"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                dateText: "FAQs",
                titleText: "We're here to help",
                introText: "Have questions? We're here to help.",
                title: "FAQs",
                aboutData: aboutData,
                contentContainerClass: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().contentContainer),
                additionalContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().drivingInnovationSection),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().drivingInnovationContent),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().drivingInnovationText),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                variant: "display-lg",
                                                color: "primary",
                                                children: "Driving Innovation with Precision and Purpose"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                variant: "text-xl",
                                                color: "grayDark-400",
                                                children: "At EPEN, we combine creativity, expertise, and dedication to craft technological solutions that empower progress and shape the future."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().drivingInnovationButtons),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            variant: "primary",
                                            label: "Get started",
                                            fullWidth: true,
                                            onClick: function() {
                                                window.location.href = "/about-us";
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageGallery),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/faq-fotter.svg",
                                    alt: "Frequently Asked Questions about EPEN Ltd. products and support"
                                })
                            })
                        ]
                    })
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().faqPage),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().contentSection),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                    className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().faqSection),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().faqSectionTitle),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                    variant: "display-md",
                                                    color: "primary",
                                                    children: "Frequently asked questions"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                    variant: "text-xl",
                                                    color: "grayDark-400",
                                                    children: "Everything you need to know about the product and billing."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().tabs),
                                            children: categories.map(function(category) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                    variant: "text-md",
                                                    as: "p",
                                                    color: "secondary",
                                                    weight: "normal",
                                                    className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().tabButton), " ").concat(selectedCategory === category ? (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active) : ""),
                                                    onClick: function() {
                                                        return setSelectedCategory(category);
                                                    },
                                                    children: category
                                                }, category);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mobiletabs),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownContainer), " dropdownContainer"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownButton),
                                                        onClick: function() {
                                                            return setIsDropdownOpen(!isDropdownOpen);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: selectedCategory
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdKeyboardArrowDown */ .Ix0, {
                                                                size: 20,
                                                                className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownIcon), " ").concat(isDropdownOpen ? (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().rotated) : "")
                                                            })
                                                        ]
                                                    }),
                                                    isDropdownOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownMenu),
                                                        children: categories.map(function(category) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownItem), " ").concat(selectedCategory === category ? (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active) : ""),
                                                                onClick: function() {
                                                                    setSelectedCategory(category);
                                                                    setIsDropdownOpen(false);
                                                                },
                                                                children: category
                                                            }, category);
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().faqItems),
                                            children: filteredFaqs.map(function(faq, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().faqItem),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().faqQuestion),
                                                            onClick: function() {
                                                                return toggleAnswer(index);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                                    variant: "text-md",
                                                                    color: "primary",
                                                                    children: faq.question
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().expandIcon),
                                                                    children: expandedQuestionIndex === index ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdRemove */ .eqC, {
                                                                        size: 20
                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdAdd */ .x06, {
                                                                        size: 20
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        expandedQuestionIndex === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().faqAnswer),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                                variant: "text-sm",
                                                                color: "grayDark-400",
                                                                children: faq.answer
                                                            })
                                                        })
                                                    ]
                                                }, faq._id);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().stillHaveQuestionsSection),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().stillHaveQuestionsContent),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().teamImages),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/get-in-touch.svg",
                                                alt: "Contact EPEN Ltd. Support Team for Additional Questions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_6___default().stillHaveQuestionsText),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                    variant: "text-xl",
                                                    color: "primary",
                                                    children: "Still have questions?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                    variant: "text-lg",
                                                    color: "grayDark-400",
                                                    children: "Can't find the answer you're looking for? Please chat to our friendly team."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            onClick: function() {
                                                window.location.href = "/contact-us";
                                            },
                                            children: "Get in touch"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (FaqPage);


/***/ }),

/***/ 70930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageWrapper_pageWrapper__MAYBo","pattern":"PageWrapper_pattern__3xQmd","headerContainer":"PageWrapper_headerContainer__DAIQD","headerSection":"PageWrapper_headerSection__BJHBX","dateContainer":"PageWrapper_dateContainer__OCDfk","dateText":"PageWrapper_dateText__ErZHL","titleContainer":"PageWrapper_titleContainer__V5tyY","mainTitle":"PageWrapper_mainTitle__yIEnc","introText":"PageWrapper_introText__ZUDXH","contentContainer":"PageWrapper_contentContainer__0fKHq"};

/***/ }),

/***/ 43260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"faq_contentContainer__DXrG4","faqPage":"faq_faqPage___wXnK","contentSection":"faq_contentSection__hHIl6","faqSection":"faq_faqSection__x8mgB","faqSectionTitle":"faq_faqSectionTitle__1Ez_A","tabs":"faq_tabs__TJrfx","tabButton":"faq_tabButton__rq6yJ","active":"faq_active__eXUZb","mobiletabs":"faq_mobiletabs__cIrkZ","dropdownContainer":"faq_dropdownContainer__m2n5M","dropdownButton":"faq_dropdownButton__t2mxv","dropdownIcon":"faq_dropdownIcon___HUPn","rotated":"faq_rotated__3JBQM","dropdownMenu":"faq_dropdownMenu__1SayY","dropdownItem":"faq_dropdownItem__APu9e","faqItems":"faq_faqItems__J2xiA","faqItem":"faq_faqItem__J0p8n","faqQuestion":"faq_faqQuestion__MpdYv","expandIcon":"faq_expandIcon__2eFxP","faqAnswer":"faq_faqAnswer__Lf8De","slideDown":"faq_slideDown__CDjHd","stillHaveQuestionsSection":"faq_stillHaveQuestionsSection__uMlD1","stillHaveQuestionsContent":"faq_stillHaveQuestionsContent__mudX_","teamImages":"faq_teamImages__ArT60","stillHaveQuestionsText":"faq_stillHaveQuestionsText__j_kcz","drivingInnovationSection":"faq_drivingInnovationSection__PBfZR","drivingInnovationContent":"faq_drivingInnovationContent__BYH0d","drivingInnovationText":"faq_drivingInnovationText__WAnT7","drivingInnovationButtons":"faq_drivingInnovationButtons__tSQCK","imageGallery":"faq_imageGallery__CBgt4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3053,3977,6538,6607,8030,1882,2033,5304,6309,9774,2888,179], function() { return __webpack_exec__(89497); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);